import { Navigate, Route, Routes } from "react-router-dom";

import type { Capabilities } from "../api/capabilities.js";
import { AccountsPage } from "../auth/AccountsPage.js";
import { LoginPage } from "../auth/LoginPage.js";
import { RequireAdmin } from "../auth/RequireAdmin.js";
import { RequireAuth } from "../auth/RequireAuth.js";
import { ItemFormPage } from "../form/ItemFormPage.js";
import { ItemListPage } from "../list/ItemListPage.js";
import { AppShell } from "../layout/AppShell.js";

export function AppRoutes({ capabilities }: { capabilities: Capabilities }) {
  return (
    <Routes>
      {/* A desktop deployment has no login screen at all: there is nothing to authenticate against a
          single till, and `RequireAuth` never redirects here on that deployment anyway (see AuthContext.tsx). */}
      <Route path="/login" element={capabilities.deployment === "desktop" ? <Navigate to="/" replace /> : <LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell capabilities={capabilities} />
          </RequireAuth>
        }
      >
        {/* The list is the layout for the intake/edit routes: it always renders,
            and those routes surface through its `<Outlet/>` as a modal floating
            over it — the web successor to legacy's `AddItemWindow.ShowDialog()`
            over `MainWindow` (MainWindow.xaml.cs:255,283). */}
        <Route path="/" element={<ItemListPage />}>
          <Route path="items/new" element={<ItemFormPage mode="create" capabilities={capabilities} />} />
          <Route path="items/:id" element={<ItemFormPage mode="edit" capabilities={capabilities} />} />
        </Route>
        {/* Admin-only, and meaningless on desktop (no accounts concept at all) — RequireAdmin redirects both a non-admin and desktop's ever-null account away. */}
        <Route
          path="accounts"
          element={
            <RequireAdmin>
              <AccountsPage />
            </RequireAdmin>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
